import Save16 from '@carbon/icons-react/es/save/16';
import React, { FC } from 'react';
import { Button, ButtonProps } from 'components/atoms/button/button';

export const SaveButton: FC<ButtonProps> = (props) => (
  <Button icon={<Save16 />} type="primary" iconPlacement="right" {...props} />
);
